import { render, staticRenderFns } from "./live-card.vue?vue&type=template&id=4253ed1d&scoped=true&"
import script from "./live-card.vue?vue&type=script&lang=js&"
export * from "./live-card.vue?vue&type=script&lang=js&"
import style0 from "./live-card.vue?vue&type=style&index=0&id=4253ed1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253ed1d",
  null
  
)

export default component.exports